import { PaginationOffsetSearchSchema } from "@design-system/pagination/schemas";
import { z } from "zod/v4";

import { OperatorSchema } from "./operator";

const CompanySchema = z.object({
  id: z.number().brand<"CompanyId", "inout">(),
  name: z.string(),
  operatorId: OperatorSchema.shape.id.nullish(),
});

type Company = z.infer<typeof CompanySchema>;
type CompanyId = Company["id"];

const CompaniesResponseSchema = z.object({
  data: z.array(CompanySchema),
});

const CompaniesSearchSchema = PaginationOffsetSearchSchema.extend({
  operatorId: OperatorSchema.shape.id
    .optional()
    .transform((val) => (val !== undefined ? String(val) : undefined)),
  include: CompanySchema.shape.id
    .optional()
    .transform((val) => (val !== undefined ? String(val) : undefined)),
  search: z
    .string()
    .optional()
    .transform((val) => (val && val.trim() ? val.trim() : undefined)),
});

type CompaniesSearchParams = z.input<typeof CompaniesSearchSchema>;

export { CompanySchema, CompaniesResponseSchema, CompaniesSearchSchema };
export type { Company, CompanyId, CompaniesSearchParams };
